<template>
<v-card>
  <v-card-actions class="secondary  white--text">
    <v-col cols="10" class="text-left">
      <h3>{{$store.getters['profile/videoTitle'](section)}}</h3>
    </v-col>
    <v-col cols="2" class="text-right">
      <v-btn small dark icon @click="$eventBus.$emit('play_video',tutorial)" v-if="!video">
        <v-icon>fa-question</v-icon>
      </v-btn>
      <v-btn dark small icon v-if="video" @click="clearFile">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-col>
  </v-card-actions>


  <!-- Upload !-->
  <div class="video-responsive" v-if="!video && !upload" @click="selectFile" @drop.prevent="handleFileChange($event)" @dragover.prevent>
    <v-row style="position:absolute;top:0px;bottom:0px;left:0px;right:0px" align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-btn large fab color="primary" :class="shouldAnimate ? 'highlight' : ''">
          <v-icon large dark>fa-plus</v-icon>
        </v-btn>
        <input type="file" style="display:none" :id="`file-${random_id}`" @change="handleFileChange($event)" accept="video/*" />
      </v-col>
    </v-row>
  </div>

  <!-- Uploading !-->
  <div class="video-responsive" v-if="upload">
    <v-row style="position:absolute;top:0px;bottom:0px;left:0px;right:0px" align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular :value="upload.progress" :size="100" :width="8" color="green"> {{ upload.progress }}</v-progress-circular>
      </v-col>
    </v-row>
  </div>

  <!-- Video !-->
  <div class="video-responsive" v-if="video">
    <video :poster="video.thumbnail ? video.thumbnail : null" controls>
  <source :src="video.url" type="video/mp4">
  <source :src="video.url" type="video/ogg">
  Your browser does not support HTML5 video.
    </video>
  </div>

  <!-- Video actions !-->
  <v-card-actions class="grey lighten-3" v-if="video">
    <span class="font-weight-bold error--text " v-if="video.approved==0">Pending Approval</span>
    <span class="blue--text font-weight-bold" v-if="$store.state.account.account.edit_claimed && section==1">Pending Edit</span>
    <v-btn text small color="primary" v-if="$store.state.account.account.edit_available && section==1" @click="claimEdit">Claim Edit</v-btn>
    <v-spacer></v-spacer>
    <span class="pull-left mr-2 pt-1 font-weight-bold grey--text text--darken-2" v-if="video">Visible</span>
    <div>
      <v-switch :disabled="!video" :true-value="1" :false-value="0" color="green" hide-details class="mt-0" inset dense :input-value="video.visible" @change="changeVisible"></v-switch>
    </div>
  </v-card-actions>

</v-card>
</template>
<script>
export default {
  props: ['title', 'section', 'tutorial'],
  name: "",
  data: () => ({
    random_id: Math.round(Math.random() * 1000000),
    placeholder: ''
  }),
  created() {

  },
  computed: {
    shouldAnimate() {
      if (this.$route.hash) {
        if (this.$route.hash.includes("section")) {
          if (parseInt(this.$route.hash.split("-")[1]) === this.section) {
            return true
          }
        }
      }
      return false

    },
    video: function() {
      return this.$store.getters['profile/video'](this.section)
    },
    upload: function() {
      return this.$store.getters['profile/upload'](this.section)
    }
  },
  methods: {
    selectFile() {
      document.querySelector(`#file-${this.random_id}`).click()
    },
    clearFile() {
      if (!confirm("Confirm delete ?")) {
        return
      }
      this.$store.dispatch('profile/deleteVideo', this.video)
    },
    claimEdit() {
      this.$store.dispatch('account/claimEdit')
    },
    changeVisible(v) {
      this.$store.dispatch("profile/updateVideo", {
        video: this.video,
        update: {
          visible: v
        }
      })
    },
    handleFileChange(ev) {
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0]
        this.$store.dispatch('profile/uploadVideo', {
          file: file,
          section: this.section
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#upload-file {
    display: none;
}
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive video {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}

.highlight {
    animation: grow 0.75s;
    animation-delay: 1s;
    animation-timing-function: ease-in;
}
@keyframes spin {
    0% {
        transform: rotate();

    }
    50% {
        transform: rotate(360deg);
        background-color: #4CAF50;
    }
    100% {
        transform: rotate();
    }
}
@keyframes grow {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);

    }
    100% {
        transform: scale(1);
    }
}
</style>
